import { Box, Button, Typography, useTheme } from "@mui/material"
import { DataGrid, GridDeleteIcon } from "@mui/x-data-grid"
import { tokens } from "../../theme"
import { mockDataTeam } from "../../data/mockData"
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined"
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined"
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined"
import Header from "../../components/Header"
import { useNavigate } from "react-router-dom"
import UsersApi from "../../services/api/users"
import { useEffect } from "react"
import { useState } from "react"
import { EditNotificationsOutlined } from "@mui/icons-material"
import ConfirmationDialog from "../../components/ConfirmationDialog"

const UsersIndex = () => {
	const navigate = useNavigate()

	const theme = useTheme()
	const colors = tokens(theme.palette.mode)
	const usersModule = UsersApi()
	const [usersList, setUsersList] = useState([])

	const [isConfirmationOpen, setConfirmationOpen] = useState(false)
	const [selectedUserId, setSelectedUserId] = useState('')

	const columns = [
		{ field: "id", headerName: "ID" },
		{
			field: "name",
			headerName: "Name",
			flex: 1,
			cellClassName: "name-column--cell",
		},
		{
			field: "contact",
			headerName: "Contact Number",
			flex: 1,
		},
		{
			field: "email",
			headerName: "Email",
			flex: 1,
		},
		{
			field: "",
			headerName: "Edit",
			flex: 1,
			renderCell: ({ row: { id } }) => {
				return (
					<Box display="flex" justifyContent="center" borderRadius="4px">
						<Typography
							variant="button"
							color="warning" 
							onClick={() => editUser(id)}
							style={{ cursor: "pointer", marginRight: "10px" }}
						>
							<EditNotificationsOutlined
								fontSize="small"
								style={{ marginRight: "4px" }}
							/>
							Edit
						</Typography>

						<Typography
							variant="button"
							color="error" 
							onClick={() => deleteUser(id)}
							style={{ cursor: "pointer" }}
						>
							<GridDeleteIcon fontSize="small" style={{ marginRight: "4px" }} />
							Delete
						</Typography>
					</Box>
				)
			},
		},
	]

	useEffect(() => {
		fetchUsers()
	}, [])

	const fetchUsers = async () => {
		try {
			const data = await usersModule.getAllUsers()

			setUsersList(data.users)
		} catch (error) {
			console.log("Not loading users", error)
		}
	}

	const createUser = () => {
		navigate("/create-user")
	}

	const editUser = (id) => {
		const user = usersList.find((user) => user.id === id)

		navigate("/create-user", { state: { user } })
	}

	const deleteUser = (id) => {
		setSelectedUserId(id)
		handleOpenConfirmation()
	}

	const handleOpenConfirmation = () => {
		setConfirmationOpen(true)
	}

	const handleCloseConfirmation = () => {
		setConfirmationOpen(false)
	}

	const handleConfirmAction = () => {
		try {
			const response = usersModule.deleteUser(selectedUserId)

			console.log("User deleted successfully: ", response)
			fetchUsers()
		} catch (error) {
			console.log("Not deleted user. ", error)
		}

		handleCloseConfirmation()
	}

	return (
		<>
			<Box m="20px">
				<Header title="USERS" subtitle="Customer care supporting team" />

				<Box display="flex" justifyContent="end" m="0 0 0 0">
					<Button
						type="submit"
						color="secondary"
						variant="contained"
						onClick={createUser}
					>
						Create New User
					</Button>
				</Box>

				<Box
					m="40px 0 0 0"
					height="75vh"
					sx={{
						"& .MuiDataGrid-root": {
							border: "none",
						},
						"& .MuiDataGrid-cell": {
							borderBottom: "none",
						},
						"& .name-column--cell": {
							color: colors.greenAccent[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							backgroundColor: colors.blueAccent[700],
							borderBottom: "none",
						},
						"& .MuiDataGrid-virtualScroller": {
							backgroundColor: colors.primary[400],
						},
						"& .MuiDataGrid-footerContainer": {
							borderTop: "none",
							backgroundColor: colors.blueAccent[700],
						},
						"& .MuiCheckbox-root": {
							color: `${colors.greenAccent[200]} !important`,
						},
					}}
				>
					<DataGrid rows={usersList} columns={columns} />
				</Box>
			</Box>

			<ConfirmationDialog
				open={isConfirmationOpen}
				onClose={handleCloseConfirmation}
				onConfirm={handleConfirmAction}
			/>
		</>
	)
}

export default UsersIndex
